import { Input } from "@/components/input";
import { Label } from "@/components/label";
import { Switch } from "@/components/switch";
import type { EmailNode } from "@repo/shared/workflow";
import type { FC } from "react";

interface EmailNodeEditorProps {
  node: EmailNode;
  onChange: (key: string, value: unknown) => void;
}

export const EmailNodeEditor: FC<EmailNodeEditorProps> = ({
  node,
  onChange,
}) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>To Username</Label>
        <Input
          value={node.toUsername}
          onChange={(e) => onChange("toUsername", e.target.value)}
          placeholder="Enter username"
        />
      </div>

      <div className="space-y-2">
        <Label>Accept From</Label>
        <Input
          value={node.acceptFrom.join(", ")}
          onChange={(e) =>
            onChange(
              "acceptFrom",
              e.target.value.split(",").map((s) => s.trim()),
            )
          }
          placeholder="Enter email addresses (comma separated)"
        />
      </div>

      <div className="flex items-center justify-between">
        <Label>Reply All</Label>
        <Switch
          checked={node.replyAll}
          onCheckedChange={(checked) => onChange("replyAll", checked)}
        />
      </div>

      <div className="flex items-center justify-between">
        <Label>Enabled</Label>
        <Switch
          checked={node.enabled}
          onCheckedChange={(checked) => onChange("enabled", checked)}
        />
      </div>

      <div className="flex items-center justify-between">
        <Label>Required</Label>
        <Switch
          checked={node.required}
          onCheckedChange={(checked) => onChange("required", checked)}
        />
      </div>
    </div>
  );
};
